import { SVGProps } from "react";

const IconInformationRed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    fontSize={props.fontSize ? props.fontSize : 16}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="7.99992" cy="8.00001" r="6.66667" stroke="#ff3333" strokeWidth={2}/>
      <path
        d="M8.65168 9.96609C8.6425 10.131 8.80054 10.23 9.12579 10.2629C9.15101 10.2654 9.17722 10.2676 9.20444 10.2693C9.31232 10.2763 9.40007 10.3628 9.40007 10.4709C9.40007 10.579 9.31243 10.6667 9.20432 10.6667H9.12579H6.99508H6.92914C6.82104 10.6667 6.7334 10.579 6.7334 10.4709C6.7334 10.3628 6.82116 10.2764 6.92901 10.2689C6.95175 10.2673 6.97377 10.2655 6.99508 10.2633C7.31382 10.2308 7.47318 10.1317 7.47318 9.96609V7.87815C7.47318 7.71297 7.32153 7.61256 7.01822 7.57692C6.98746 7.57331 6.95513 7.57036 6.92125 7.56807C6.81767 7.5611 6.7334 7.47805 6.7334 7.37424C6.7334 7.26184 6.82452 7.17072 6.93692 7.17072H7.18545H8.34473H8.42301C8.5493 7.17072 8.65168 7.2731 8.65168 7.39939V9.96609ZM8.7549 6.01686C8.7549 6.17712 8.68322 6.31677 8.53985 6.43582C8.40222 6.55029 8.23017 6.60753 8.02372 6.60753C7.9205 6.60753 7.823 6.5915 7.73125 6.55945C7.64523 6.5274 7.56781 6.48619 7.49899 6.43582C7.43591 6.38087 7.38429 6.31906 7.34415 6.25038C7.30401 6.17712 7.28394 6.09928 7.28394 6.01686C7.28394 5.85202 7.35562 5.61491 7.49899 5.50502C7.64809 5.39055 7.823 5.33331 8.02372 5.33331C8.22444 5.33331 8.39648 5.39055 8.53985 5.50502C8.68322 5.61949 8.7549 5.8566 8.7549 6.01686Z"
        fill="#ff3333" strokeWidth={2}
      />
  </svg>
);

export default IconInformationRed;
